import { Pipe, PipeTransform } from '@angular/core'

import { isArray, orderBy } from 'lodash'

@Pipe({
  name: 'flxOrderBy',
  standalone: true,
})
export class FlxOrderByPipe implements PipeTransform {
  transform(input: any, prop: string): Array<any> {
    if (!isArray(input) || !prop) {
      return input
    }
    return orderBy(input, prop)
  }
}
